/**
 * @param {string?} value
 */
export const normalizeData = (value) => {

	if (value === 'true' || value === '') {
		return true;
	}

	if (value === 'false') {
		return false;
	}

	if (value === Number(value).toString()) {
		return Number(value);
	}

	if (value === 'null') {
		return null;
	}

	if (typeof value !== 'string') {
		return value;
	}

	// Decode json object
	try {
		return JSON.parse(value);
	}
	// not json
	catch {
		return value;
	}
};

/**
 * @param {HTMLElement} element
 * @param {string} prefix
 */
export const getOptionsFromDataset = (element, prefix = '', processResponsive = false) => {

	// No element/prefix/dataset
	if (!element || !prefix || !element.dataset) {
		return {};
	}

	// Convert prefix to camel-case
	if (prefix.includes('-')) {
		prefix = mpro.camelize(prefix);
	}

	let options = Object.create(null);
	let optionsDesktop;
	let optionsMobile;

	if (processResponsive) {
		if (mpro.isMobileScreen()) {
			optionsMobile = Object.create(null);
		}
		else {
			optionsDesktop = Object.create(null);
		}
	}

	// Get object data from prefix
	const data = element.dataset[prefix];
	// Allow only objects, nothing else
	if (data && data[0] === '{') {
		try {
			options = JSON.parse(data);
		}
		catch {
			// not json
		}
	}

	// Get data from individual properties
	for (const name of Object.keys(element.dataset)) {
		if ((name !== prefix) && name.startsWith(prefix)) {
			let prop = name.slice(prefix.length);
			prop = prop[0].toLowerCase() + prop.slice(1);

			// Use the mobile option instead
			if (processResponsive && /^mobile[\dA-Z]/.test(prop)) {
				if (optionsMobile) {
					prop = prop.slice(6);
					prop = prop[0].toLowerCase() + prop.slice(1);
					optionsMobile[prop] = normalizeData(element.dataset[name]);
				}
			}
			// Use the desktop option instead
			else if (processResponsive && /^desktop[\dA-Z]/.test(prop)) {
				if (optionsDesktop) {
					prop = prop.slice(7);
					prop = prop[0].toLowerCase() + prop.slice(1);
					optionsDesktop[prop] = normalizeData(element.dataset[name]);
				}
			}
			// Use the default option
			else {
				options[prop] = normalizeData(element.dataset[name]);
			}
		}
	}

	// Mobile options take precedence
	if (optionsMobile) {
		options = { ...options, ...optionsMobile };
	}
	// Desktop options are last
	else if (optionsDesktop) {
		options = { ...options, ...optionsDesktop };
	}

	return options;
};
